import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";
import { SiPowerBolt } from "../../images/icons/components/SiPowerBolt";

export function UnlockButton({
  children,
  onClick,
  isLoading,
  isDisabled,
  ...props
}: ButtonProps) {
  return (
    <Button
      leftIcon={<SiPowerBolt />}
      colorScheme="primary"
      onClick={onClick}
      isLoading={isLoading}
      width="full"
      disabled={isDisabled}
      {...props}
    >
      {children}
    </Button>
  );
}
